import { Description, Label, Radio, RadioGroup } from '@headlessui/react'
export type { RadioGroupProps as HeadlessRadioGroupProps, RadioProps as HeadlessRadioOptionProps } from '@headlessui/react'

export const HeadlessRadioGroup = Object.assign(RadioGroup, {
  Description: Description,
  Label: Label,
  Option: Radio
})
